import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import {AccountRequestDto} from "../dto/account.request.dto";

@Injectable({
    providedIn: 'root',
})
export class UserSubject {
    // Comenzamos con un objeto vacío o null, con Partial para poder construir el objeto progresivamente
    private registrationDataSubject = new BehaviorSubject<Partial<AccountRequestDto>>({});

    // Observable que permite suscribirse a los datos del registro
    registrationData$ = this.registrationDataSubject.asObservable();

    // Método para actualizar los datos en el BehaviorSubject
    updateRegistrationData(data: Partial<AccountRequestDto>) {
        const currentData = this.registrationDataSubject.value;
        const updatedData = { ...currentData, ...data };  // Combinar los nuevos datos con los anteriores
        this.registrationDataSubject.next(updatedData);  // Emitir los datos actualizados
    }

    // Obtener los datos actuales del registro (último valor emitido)
    getRegistrationData(): Partial<AccountRequestDto> {
        return this.registrationDataSubject.value;
    }

    // Limpiar los datos después de que se haya completado el registro o si se quiere reiniciar
    clearData() {
        this.registrationDataSubject.next({});  // Limpiar los datos almacenados
    }
}
